import React from 'react';
import { Button, Col, ControlLabel, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { stakeholderTypeOptions } from '../../../containers/organizations/utils/stakeholdersStructure.js';
import { FormError } from '../../FormError.jsx';
import GroupStakeholderFields from './GroupStakeholderFields.jsx';
import IndividualStakeholderFields from './IndividualStakeholderFields.jsx';
import RadioAdapter from '../../RadioAdapter.jsx';

function StakeholdersManuallyForm({
  stakeholdersStructure,
  onAddNewStakeholder,
  onUpdateStakeholderField,
  onDeleteStakeholder,
  handleSubmit,
  formRef,
  submitError,
  submitFailed,
  submitting,
  onCancel,
}) {
  return (
    <form onSubmit={handleSubmit} ref={formRef}>
      <Row>
        <Col xs={12} className="m-b-24">
          <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
            <h3>Edit Stakeholders</h3>
          </div>
        </Col>
      </Row>

      {stakeholdersStructure.map((stakeholder, index) => (
        <Row key={index}>
          <Col xs={12}>
            <h3>
              <ControlLabel>{index + 1} Stakeholder Info</ControlLabel>
            </h3>
          </Col>
          <Col xs={12}>
            <div className="m-b-24">
              {stakeholderTypeOptions.map((option) => (
                <Field
                  key={option.value}
                  name={`stakeholder.${index}.objectType`}
                  component={RadioAdapter}
                  label={option.label}
                  type="radio"
                  checked={
                    stakeholdersStructure[index].objectType === option.value
                  }
                  onChange={() =>
                    onUpdateStakeholderField(index, 'objectType', option.value)
                  }
                  value={option.value}
                />
              ))}
            </div>
          </Col>
          <Col xs={12}>
            {stakeholder.objectType === 'group' ? (
              <GroupStakeholderFields
                index={index}
                stakeholdersStructure={stakeholdersStructure}
                onUpdateStakeholderField={onUpdateStakeholderField}
                onDeleteStakeholder={onDeleteStakeholder}
              />
            ) : (
              <IndividualStakeholderFields
                index={index}
                stakeholdersStructure={stakeholdersStructure}
                onUpdateStakeholderField={onUpdateStakeholderField}
                onDeleteStakeholder={onDeleteStakeholder}
              />
            )}
          </Col>
        </Row>
      ))}

      <Row className="m-b-48">
        <Col xs={12}>
          <button
            type="button"
            className="btn-link"
            onClick={onAddNewStakeholder}
          >
            {' '}
            + Add New Stakeholder
          </button>
        </Col>
      </Row>

      <Row className="m-b-48">
        {submitFailed && submitError ? (
          <FormError submitError={submitError} />
        ) : null}
        <Col xs={12}>
          <div className="flex">
            <div>
              <Button bsStyle="default" onClick={onCancel}>
                Cancel
              </Button>

              <Button
                className="m-l-12"
                bsStyle="primary"
                disabled={submitting}
                type="submit"
              >
                {submitting ? 'Saving...' : 'Save'}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </form>
  );
}

export default StakeholdersManuallyForm;
